var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLucidePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing Page - Option2",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    transform: "translate(-599 -6860)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop - 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-601 -169C-601 -196.614 -578.614 -219 -551 -219H791C818.614 -219 841 -196.614 841 -169V458H-601V-169Z",
    fill: "url(#paint0_linear_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lucide:phone",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3912 14.2866V16.7945C18.3922 17.0273 18.3445 17.2578 18.2512 17.4711C18.1579 17.6844 18.0211 17.8759 17.8496 18.0333C17.678 18.1907 17.4755 18.3105 17.2549 18.3851C17.0344 18.4597 16.8007 18.4874 16.5688 18.4665C13.9964 18.1869 11.5255 17.3079 9.35445 15.9C7.33462 14.6166 5.62215 12.9041 4.33867 10.8843C2.92587 8.7034 2.04666 6.22041 1.77226 3.63645C1.75137 3.40528 1.77884 3.17229 1.85293 2.95232C1.92702 2.73234 2.0461 2.53021 2.20258 2.35878C2.35907 2.18735 2.54954 2.05038 2.76186 1.9566C2.97419 1.86281 3.20371 1.81426 3.43583 1.81405H5.94372C6.34942 1.81005 6.74273 1.95372 7.05034 2.21826C7.35795 2.48281 7.55887 2.85018 7.61565 3.2519C7.7215 4.05449 7.91781 4.84252 8.20082 5.60096C8.3133 5.90017 8.33764 6.22536 8.27097 6.53798C8.20429 6.8506 8.0494 7.13756 7.82464 7.36485L6.76296 8.42652C7.95301 10.5194 9.68587 12.2523 11.7787 13.4423L12.8404 12.3806C13.0677 12.1559 13.3547 12.001 13.6673 11.9343C13.9799 11.8676 14.3051 11.892 14.6043 12.0044C15.3628 12.2875 16.1508 12.4838 16.9534 12.5896C17.3595 12.6469 17.7303 12.8515 17.9954 13.1643C18.2605 13.4772 18.4014 13.8767 18.3912 14.2866Z",
    stroke: "white",
    strokeWidth: 1.67193,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -601,
    y1: -219,
    x2: 825.75,
    y2: 459.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED9232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#814403"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7318,
    fill: "white",
    transform: "translate(-599 -6860)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0631,
    height: 20.0631,
    fill: "white",
    transform: "translate(0 0.14209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucidePhone);
export default __webpack_public_path__ + "static/media/lucide_phone.690da4dd3503816e6793974c8c737ba3.svg";
export { ForwardRef as ReactComponent };